export default class CssContext {
    static getContext() {
        if (!window.getComputedStyle) {
            return 'desktop';
        }
        return window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/"/g, '');
    }
}
